"use client"

import { useEffect } from 'react'
import { dataService } from '@/lib/data-service'

export function DataInitializer() {
  useEffect(() => {
    dataService.initializeData()
  }, [])

  return null
}